import { defineStore } from 'pinia'
import type { User, Notification } from '~/types'

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null as User | null,
        preferences: null as Notification | null,
        users: [] as User[]
    }),

    actions: {
        async setUser(user: User) {
            this.user = user
        },
        async getUser() {
            const { $api } = useNuxtApp();

            await $api.get("/me").then((response) => {
                this.setUser(response.data);
            });
        },

        async init() {
            await this.getUser();
        },

        updateUser(user: User) {
            this.user = user
        },

        async fetchNotificationPreferences() {
            const { $api } = useNuxtApp();
            await $api.get(`/me/notifications`).then((response) => {
                this.preferences = response.data
            });
        },

        clear() {
            this.user = null
        },

        async fetchUsers() {
            const { $api } = useNuxtApp();
            await $api.get(`/users`).then((response) => {
                this.users = response.data
            });
        }
    }
})